import React, { useState } from "react";
import { Box, Tab, Tabs, Typography, Paper, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import IncidentVideosTab from "../../Components/Common/IncidentVideosTab";
import ExitBlockingPolygonEditor from "../../Components/ExitBlocking/ExitBlockingPolygonEditor";
import ExitBlockingIncidentsChart from "../../Components/ExitBlocking/ExitBlockingIncidentsChart";
import ExitBlockingConfidenceAudit from "../../Components/ExitBlocking/ExitBlockingConfidenceAudit";
import { baseURL } from "../../utils/StaticVariables";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`exit-blocking-tabpanel-${index}`}
      aria-labelledby={`exit-blocking-tab-${index}`}
      style={{ minHeight: "calc(100vh - 200px)" }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, animation: "fadeIn 0.5s ease-in-out" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `exit-blocking-tab-${index}`,
    "aria-controls": `exit-blocking-tabpanel-${index}`,
  };
}

const ExitBlockingVisualizations = () => {
  const [selectedChart, setSelectedChart] = useState("incidents_per_camera");

  return (
    <Box sx={{ p: 1, display: "flex", flexDirection: "column", width: "100%" }}>
      <Box sx={{ maxWidth: 400, mb: 4 }}>
        <FormControl fullWidth>
          <InputLabel id="exit-blocking-vis-select-label">Select Visualization</InputLabel>
          <Select
            labelId="exit-blocking-vis-select-label"
            value={selectedChart}
            label="Select Visualization"
            onChange={(e) => setSelectedChart(e.target.value)}
          >
            <MenuItem value="incidents_per_camera">
              Number of Incidents per Camera
            </MenuItem>
            <MenuItem value="confidence_audit">
              Model Confidence Audit
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ animation: "fadeIn 0.5s ease-in-out", width: "100%" }}>
        {selectedChart === "incidents_per_camera" ? (
          <ExitBlockingIncidentsChart />
        ) : (
          <ExitBlockingConfidenceAudit />
        )}
      </Box>
    </Box>
  );
};

const ExitBlockingMain = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: "bold" }}>
        Exit Blocking & Pathway Monitoring
      </Typography>

      <Paper elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "background.paper" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Exit Blocking dashboard tabs"
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            sx={{
              "& .MuiTab-root": {
                fontWeight: 600,
                fontSize: "1rem",
                textTransform: "none",
                py: 2.5,
              },
            }}
          >
            <Tab label="Incident Videos" {...a11yProps(0)} />
            <Tab label="Visualizations" {...a11yProps(1)} />
            <Tab label="Area of Interest" {...a11yProps(2)} />
          </Tabs>
        </Box>

        <Box sx={{ bgcolor: "background.default" }}>
          <CustomTabPanel value={value} index={0}>
            <IncidentVideosTab
              featureName="Exit Blocking"
              featureKey="exit_blocking"
              apiEndpoint={`${baseURL}blocked-exit/events`}
              resolveEndpoint={`${baseURL}blocked-exit/events/{event_id}/resolve`}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <ExitBlockingVisualizations />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <ExitBlockingPolygonEditor />
          </CustomTabPanel>
        </Box>
      </Paper>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </Box>
  );
};

export default ExitBlockingMain;
